module.exports = __webpack_public_path__ + "img/p23.ecddc4f1.png";